export const convertCelsiusToFahrenheit = (temperature: number) => {
  return ((temperature * 9) / 5 + 32).toFixed(1)
}

export const convertFahrenheitToCelsius = (fahrenheit: number) =>
  (((fahrenheit - 32) * 5) / 9).toFixed(1);

export const isObject = (value: any): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

export const isInStandaloneMode = () =>
  (window.navigator as any).standalone || window.matchMedia('(display-mode: standalone)').matches;


export const displayFloorAndDoorByName = (name: string | null) => {
  let floor = null;
  let door = null;
  if (name) {
    const parts = name.split('-');
    //if (parts.length < 4) return { floor: null, door: null }; 

    const numberPart = parts[parts.length - 1];
    if (!/^\d+$/.test(numberPart)) return <p>Error</p> // Nem szám

    if (numberPart.length === 3) {
      door = numberPart;
    } else if (numberPart.length === 4) {
      floor = numberPart.slice(0, 2);
      door = numberPart.slice(2, 4)
    }
  }

  return (
    <span>
      {floor && <span>{floor},</span>}
      {door && <span>{door}</span>}
    </span>
  )
};

export const sortByApartmentName = (apartments: any) => {
  return apartments.sort((a: any, b: any) => {
    const numA = a.name.match(/\d+/g)?.map(Number) || [];
    const numB = b.name.match(/\d+/g)?.map(Number) || [];

    for (let i = 0; i < Math.min(numA.length, numB.length); i++) {
      if (numA[i] !== numB[i]) {
        return numA[i] - numB[i]; // Számok alapján növekvő sorrend
      }
    }

    return a.name.localeCompare(b.name); // Ha nincs szám vagy egyenlő, ABC szerint rendez
  });
}

export const hashPassword = async (password: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};